module.exports = __webpack_public_path__ + "bin/d3ec4ee7bb1ab97e707987afa9795e28.png";